var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Box } from 'wix-style-react';
import { InfoLine } from '../InfoSection';
export var Amount = function (_a) {
    var amount = _a.amount, dataHook = _a.dataHook, formatMoney = _a.formatMoney, heading = _a.heading, title = _a.title, weight = _a.weight, rest = __rest(_a, ["amount", "dataHook", "formatMoney", "heading", "title", "weight"]);
    var styleProps = heading ? { heading: heading } : { weight: weight };
    var renderTitle = function () { return (React.createElement(InfoLine, __assign({ flex: 1 }, styleProps, { dataHook: "".concat(dataHook, ".title") }), title)); };
    var renderAmount = function () { return (React.createElement(InfoLine, __assign({}, styleProps, { dataHook: "".concat(dataHook, ".amount") }), formatMoney(amount))); };
    return (React.createElement(Box, __assign({}, rest, { dataHook: dataHook }),
        renderTitle(),
        renderAmount()));
};
//# sourceMappingURL=Amount.js.map